import { API } from './lib/api';

//Checks if localStorage is available
function storageAvailable(type) {
  var storage;
  try {
    storage = window[type];
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  }
  catch (e) {
    return e instanceof DOMException && (
      // everything except Firefox
      e.code === 22 ||
      // Firefox
      e.code === 1014 ||
      // test name field too, because code might not be present
      // everything except Firefox
      e.name === 'QuotaExceededError' ||
      // Firefox
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      (storage && storage.length !== 0);
  }
}



/**
 * Fetches all attributes from the REST API.
 * @returns Array of attributes.
 */
async function getAllAttributes() {
  try {
    const attributesQuery = await API.listAttributes();
    const items = attributesQuery.data.listAttributes.items;
    return items;
  }
  catch (e) {
    return [];
  }
}


//Stores all of the attributes that are used for the filters in localStorage. Stores attributes in localStorage for 1 hour before refreshing them.
export async function populateLocalStorage() {
  //Check if localStorage is available
  if (!storageAvailable('localStorage')) {
    return;
  }

  //Check if 'attributes' already exist in localStorage
  const existingAttributes = localStorage.getItem('attributes');
  if (existingAttributes !== null) {
    try {
      const parsed = JSON.parse(existingAttributes);
      const attributesTimestamp = parsed.timestamp;
      const hasValidData = parsed.filterOptions && Array.isArray(parsed.filterOptions) && parsed.filterOptions.length > 0;

      // Check if attributes are older than an hour OR if they're empty/invalid
      const isExpired = (attributesTimestamp + 3600000) < Date.now();
      if (isExpired || !hasValidData) {
        localStorage.removeItem('attributes');

        //Calls getAllAttributes() and then stores the result in localStorage under 'attributes'.
        const result = await getAllAttributes();
        const attributes = {
          filterOptions: result || [],
          timestamp: Date.now()
        };
        localStorage.setItem('attributes', JSON.stringify(attributes));
        // Dispatch custom event to notify components
        window.dispatchEvent(new Event('localStorage:attributesUpdated'));
      }
    } catch (e) {
      // If parsing fails, fetch new data
      const result = await getAllAttributes();
      const attributes = {
        filterOptions: result || [],
        timestamp: Date.now()
      };
      localStorage.setItem('attributes', JSON.stringify(attributes));
      window.dispatchEvent(new Event('localStorage:attributesUpdated'));
    }
  }
  else {
    const result = await getAllAttributes();
    const attributes = {
      filterOptions: result || [],
      timestamp: Date.now()
    };
    localStorage.setItem('attributes', JSON.stringify(attributes));
    // Dispatch custom event to notify components
    window.dispatchEvent(new Event('localStorage:attributesUpdated'));
  }
}